import React from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {findKeysByName} from "../utils/helpers";
import {NavLink} from "react-router-dom";

const Gallery = () => {
    // All product data in one array ✅
    const products = [
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070810/RivetNuts_bnbobx.webp", name: "Rivet Nuts M5" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759242759/BlindStandoffs_ikm3w8.webp", name: "Blind Standoffs" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165612/HexWeldNuts_iwjqrc.webp", name: "Hex Weld Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165595/CageNuts_xyfsdl.webp", name: "Cage Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165597/CountersunkHead_sb9xs7.webp", name: "Countersunk Head" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165600/FlangeBolts_takwzg.webp", name: "Flange Bolts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165605/FlushHeadStuds_vskogx.webp", name: "Flush Head Studs" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165602/FlangeHeadRivet_ii2nh2.webp", name: "Flange Head Rivet" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165607/HeavyHexBolts_xx6h1o.webp", name: "Heavy Hex Bolts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165608/HexBolts_pgfidx.webp", name: "Hex Bolts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759171102/BlindNuts_g0g7wc.webp", name: "Blind Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165644/SelfClinchingNuts_rksv6u.webp", name: "Self Clinching Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165614/PanHeadScrew_crrleo.webp", name: "Pan Head Screw" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165647/SemiTabularRivets_bkvkfa.webp", name: "Semi Tabular Rivets" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165641/PopRivets_nloyn7.webp", name: "Pop Rivets" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165650/SolidRivets_gzdimd.webp", name: "Solid Rivets" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165653/ThroughStandoffs_fzxdeh.webp", name: "Standoffs" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165655/WeldBolt_ece24l.webp", name: "Weld Bolt" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759601197/ExternalCirclips_ivssyh.webp", name: "External Circlips" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759241582/SquareWeldNuts_txujdh.webp", name: "Square Weld Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1760968659/ClosedEndRivetNuts_f1grgi.webp", name: "Closed End Hex Rivet" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070858/RivetNutFullHex_igmxuy.webp", name: "Full Hex Rivet Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070889/Pneumatic_Rivet_Gun_ao3cec.webp", name: "Pneumatic Rivet Gun" },
    ];

    const renderBanner = () => (
        <div className="bg-secondary position-relative" style={{overflow: "hidden"}}>
            <img
                src="https://res.cloudinary.com/dbirahuue/image/upload/v1759158411/GallaryImg_zhycs0.webp"
                className="img-fluid w-100"
                alt="Banner"
                style={{
                    width: "100%",
                    maxHeight: "600px",
                    objectFit: "cover",
                    mixBlendMode: "multiply",
                }}
            />
            <div className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100">
                {/* Large screens */}
                <h2 className="d-none d-lg-block text-white text-center text-uppercase p-2 bg-secondary bg-opacity-50" data-aos="zoom-in" style={{letterSpacing: "5px"}}>Gallery</h2>

                {/* Small/medium screens */}
                <h4 className="d-block d-lg-none p-2 text-white text-center text-uppercase p-2 mx-3 bg-secondary bg-opacity-50" data-aos="zoom-in" style={{letterSpacing: "5px"}}>Gallery</h4>
            </div>
        </div>
    );

    const renderImages = () => (
        <div className="container my-5">
            <div className="row g-4 row-cols-1 row-cols-md-2 row-cols-lg-4 justify-content-center">
                {products.map((product, index) => {
                    const keys = findKeysByName(product.name);
                    return (
                        <div className="col px-4" key={index}>
                            <div
                                className="bg-light rounded-0 h-100 d-flex flex-column justify-content-center align-items-center"
                                data-aos="fade-up">
                                {keys ? (
                                    <NavLink
                                        to={`/products/${keys.categoryKey}/${keys.typeKey}`}
                                        className="d-block w-100"
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        <LazyLoadImage
                                            src={product.src}
                                            className="img-fluid rounded-0 w-100"
                                            alt={product.name}
                                            style={{height: "200px", width: "100%", objectFit: "cover"}}
                                            data-aos="zoom-in"
                                        />
                                    </NavLink>
                                ) : (
                                    <LazyLoadImage
                                        src={product.src}
                                        className="img-fluid rounded-0 w-100"
                                        alt={product.name}
                                        style={{height: "200px", width: "100%", objectFit: "cover"}}
                                        data-aos="zoom-in"
                                    />
                                )}
                                <p className="text-dark text-center py-2 mb-0">{product.name}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );

    return (
        <div className="container-fluid p-0 gradient-color">
            {renderBanner()}
            {renderImages()}
        </div>
    );
};

export default Gallery;
